import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import { type CreditCardItem } from '@webapp/modules/accounts-payable/entities/CreditCardItem'
import messages from './messages'
import { useMutateArchiveCreditCardItem } from '../../models'

// No confirmation dialog — archiving is an immediate, reversible action
// (BHV-020). Consumed by the details Active-tab row menu and the match
// screen's CC-pane "Remove Item" (BHV-051, cluster 2.3).
export const useArchiveCreditCardItemPresenter = () => {
  const intl = useProcurifyIntl()
  const { archive, isLoading } = useMutateArchiveCreditCardItem()

  const archiveCreditCardItem = async (item: CreditCardItem) => {
    try {
      await archive({ id: item.id })

      toast.success({
        title: intl.formatMessage(messages.successTitle),
        children: intl.formatMessage(messages.successMessage, {
          description: item.description,
        }),
      })
    } catch (error) {
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          getMessageFromError(error) ??
          intl.formatMessage(messages.genericErrorMessage),
      })
    }
  }

  return {
    commands: {
      archive: archiveCreditCardItem,
    },
    states: {
      isArchiving: isLoading,
    },
  }
}
